import { LoaderScreen } from '@/components/Elements/LoaderScreen';
import { apolloClient, ApolloProvider } from '@/lib/graphql';
import { queryClient } from '@/lib/react-query';
import { appRouter } from '@/routes';
import { ErrorScreen } from '@/pages/ErrorScreen';
import { QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { RouterProvider } from 'react-router-dom';

const ErrorBoundaryFallback = ({ error }: FallbackProps) => {
  const message =
    error && typeof error === 'object' && 'message' in error
      ? String((error as { message?: unknown }).message)
      : undefined;

  return <ErrorScreen error={message ? { message } : undefined} />;
};

export const AppProvider = () => {
  return (
    <React.Suspense fallback={<LoaderScreen />}>
      <ApolloProvider client={apolloClient}>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
            <RouterProvider
              router={appRouter}
              fallbackElement={<LoaderScreen />}
            />
          </ErrorBoundary>
        </QueryClientProvider>
      </ApolloProvider>
    </React.Suspense>
  );
};
